import request from '@/utils/request'

let Ma_safety_investmentApi = {

  /*安全投入列表*/
  list(data) {
    return request._post('/shop/plus.ma_safety_investment.Index/index', data);
},
/*添加安全投入*/
add(data) {
    return request._post('/shop/plus.ma_safety_investment.Index/add', data);
},
/*修改安全投入*/
edit(data) {
    return request._post('/shop/plus.ma_safety_investment.Index/edit', data);
},
/*删除安全投入*/
del(data) {
    return request._post('/shop/plus.ma_safety_investment.Index/del', data);
},
/*安全投入详情*/
detail(data) {
  return request._post('/shop/plus.ma_safety_investment.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_safety_investment.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_safety_investment.Setting/getSetting', data, errorback);
    },

    importData(data) {
        return request._post('/shop/plus.ma_safety_investment.Index/import', data);
    },
    exportExcel(data) {
        return request._post('/shop/plus.ma_safety_investment.Index/export', data);
    },
}
export default Ma_safety_investmentApi;



// WEBPACK FOOTER //
// ./src/api/ma_safety_investment.js